import {gql} from "@apollo/client";
import {mutate, query} from "../../lib/apollo";

export type DemandIo = {
    id: number;
    month: number;
    year: number;
    hpCompanyId: number;
    companyName: string;
    brokerId: number;
    brokerName: string;
    schoolGroupId: number;
    schoolGroupName: string;
    amount: number;
};

export async function fetchDemandIos(month: number, year: number): Promise<DemandIo[]> {
    const res = await query(gql`
        query q($month: Int!, $year: Int!) {
            demandIos(month: $month, year: $year) {
                id month year
                hpCompanyId companyName
                brokerId brokerName
                schoolGroupId schoolGroupName
                amount
            }
        }
    `, {month, year});
    return res?.demandIos || [];
}

export async function searchDemandSchoolGroups(search: string) {
    const res = await query(gql`
        query q($search: String) {
            demandSchoolGroups(search: $search) { id name }
        }
    `, {search});
    return (res?.demandSchoolGroups || []).map((s: any) => ({
        id: s.id,
        value: `${s.name} (${s.id})`,
    }));
}

export async function saveDemandIo(input: {
    id?: number | null;
    month: number;
    year: number;
    hpCompanyId: number;
    brokerId: number;
    schoolGroupId: number;
    amount: number;
}) {
    const res = await mutate(gql`
        mutation m($input: DemandIoWrite!) {
            demandIoUpsert(input: $input) { id }
        }
    `, {input});
    return res?.demandIoUpsert;
}

export async function deleteDemandIo(id: number) {
    await mutate(gql`
        mutation m($id: Int!) {
            demandIoDelete(id: $id)
        }
    `, {id});
}
